

import CustomerInvoiceTemplate from "./CustomerInvoiceAfterEnd";

// 📋 **handleBrowserPrint** - دالة طباعة الفاتورة عبر المتصفح
// 📋 **CustomerInvoiceTemplate** - قالب فاتورة الشحنة
export const handleBrowserPrint = async (orderDetails, invoiceData, orderId) => {
  const printWindow = window.open("", "printWindow", "width=400,height=600");
  if (!printWindow) {
    alert("⚠️ المتصفح منع نافذة الطباعة. اسمح بالنوافذ المنبثقة.");
    return;
  }

  // استدعاء **CustomerInvoiceTemplate** لإنشاء محتوى الفاتورة
  const html = await CustomerInvoiceTemplate(orderDetails, invoiceData, orderId);

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.focus();

  const tryClose = () => {
    try {
      if (printWindow && !printWindow.closed) printWindow.close();
    } catch (e) {}
  };

  printWindow.onafterprint = tryClose;
  try {
    printWindow.addEventListener && printWindow.addEventListener("afterprint", tryClose);
  } catch (e) {}

  const fallbackTimer = setTimeout(() => tryClose(), 12000);

  // ✅ انتظر تحميل الصور/الخطوط ثم اطبع
  const safePrint = async () => {
    try {
      // لو السكريبت داخل الـ HTML اتسجل
      if (printWindow.__waitForAssets) {
        await printWindow.__waitForAssets();
      } else {
        // fallback بسيط
        await new Promise((r) => setTimeout(r, 400));
      }
    } catch (e) {}

    try {
      printWindow.print();
    } catch (e) {
      console.error("❌ فشل أمر الطباعة", e);
    }
  };

  await safePrint();

  const pollInterval = setInterval(() => {
    if (!printWindow || printWindow.closed) {
      clearInterval(pollInterval);
      clearTimeout(fallbackTimer);
    }
  }, 500);
};
